define('viewModels/privileged/qm/policies/editors/AniSelectorView',[
    'lib/knockout',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n',
    'lib/knockout.validation'
], function (ko, ViewModel) {
    'use strict';

    /**
     * The AniSelectorView class.
     * @class
     */
    var AniSelectorView = ViewModel.extend(function (aniObservable) {
        var self = this;

        self.ani = ko.observable();

        self.subscribe(self.ani, function(newValue) {
            if (newValue) {
                aniObservable({ id: newValue, name: newValue });
                self.ani(null);
            }
        });

    });

    return AniSelectorView;
});

